import GeoMap from "./GeoMap";
import SimpleWhiteBox from "./SimpleWhiteBox";

export default function CityMap(props){
    const city = props.city;

    return (
        <SimpleWhiteBox content={
            <div style={{ height: '500px', position:'sticky' }}>
                <GeoMap cityes={[city]} activeLink={false}/>
            </div>
        } />
        
    )
}